import React from 'react';
import Link from 'next/link';
import Layout from '@/components/layout/Layout';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/shadcn/card';
import { Button } from '@/components/shadcn/button';
import UserStore from '@/utils/session';

export default function Index() {
  return (
    <Layout>
      <div className="container flex size-full flex-1 items-center justify-center">
        <Card className="w-full max-w-[328px]">
          <CardHeader className="pb-4 ">
            <CardTitle className="text-center text-base leading-normal sm:text-xl">
              Interested in accessing the world&apos;s freshest map data?
            </CardTitle>
          </CardHeader>
          <CardContent className="pb-4 text-center text-xs sm:text-base">
            Console offers all the core features you need to gain access to map
            data products.
          </CardContent>
          <CardFooter className="flex justify-center">
            <Link href="/login?redirectTo=/console" className="w-full">
              <Button className="w-full">Create Account</Button>
            </Link>
          </CardFooter>
        </Card>
      </div>
    </Layout>
  );
}

export const getServerSideProps = async () => {
  const user = UserStore.get();

  if (user) {
    return {
      redirect: {
        destination: `/console/developers/api-key`,
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
};
